import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsFormControl, BsFormSelect, BsFormWithButtons } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet, apiUrl, getSession } from '../../utils/api';
import { appendArrayToFormData } from '../../utils/functions';

export default function DescargarHojasDeFichaje(props) {
    const usuario = getSession();

    // submit
    const descargarZip = async data => {
        const url = apiUrl("hojasdefichaje/zip", {
            desde: data.get('desde'),
            hasta: data.get('hasta'),
            departamentos: data.get("departamento"),
            trabajador: data.get('trabajador'),
        });
        window.location.replace(url);
    }

    // render
    return <>
        <h2>Descargar hojas firmadas</h2>
        <BsFormWithButtons
            saveBtnText="Generar y descargar"
            isNew saveOnEnter
            onSave={descargarZip}>
            <DescargarZipForm
                selectDepartamento={usuario.permisoAdmin} />
        </BsFormWithButtons>
    </>;
}

class DescargarZipForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listDepartamentos: null,
            listTrabajadores: null,
            refreshKeyTrabajadores: Math.random()
        };
        this.refresh = this.refresh.bind(this);
        this.handleDepartamentoChange = this.handleDepartamentoChange.bind(this);
    }

    componentDidMount() {
        this.updateDepartamentos();
        this.updateTrabajadores();
    }

    refresh() {
        this.setState({ refreshKey: Math.random() });
    }

    handleDepartamentoChange(element) {
        this.updateTrabajadores(element ? element.value : null);
    }

    async updateDepartamentos() {
        this.setState({ listDepartamentos: await apiGet("departamentos/list") });
    }

    async updateTrabajadores(departamento) {
        let trabajadores;
        if (departamento) {
            const formData = new FormData;
            appendArrayToFormData(formData, "departamentos", [departamento]);
            trabajadores = await apiForm("usuarios/listtrabajadores", formData);
        } else {
            trabajadores = await apiGet("usuarios/listtrabajadores");
        }
        this.setState({
            listTrabajadores: trabajadores,
            refreshKeyTrabajadores: Math.random()
        });
    }

    render() {
        const ready = this.state.listTrabajadores &&
            (!this.props.selectDepartamento || this.state.listDepartamentos);
        return ready ? <>
            <Row className="gy-3" key={this.state.refreshKey}>
                { /* Fechas */}
                <Col md="6">
                    <BsFormControl label="Desde" name="desde" type="month" />
                </Col>
                <Col md="6">
                    <BsFormControl label="Hasta" name="hasta" type="month" />
                </Col>
                { /* Trabajadores */}
                {this.props.selectDepartamento &&
                    <Col md="6">
                        <BsFormSelect
                            label="Departamento" name="departamento"
                            options={this.state.listDepartamentos}
                            onChange={this.handleDepartamentoChange}
                            isClearable />
                    </Col>
                }
                <Col md="6">
                    <BsFormSelect
                        label="Trabajador" name="trabajador"
                        options={this.state.listTrabajadores}
                        key={this.state.refreshKeyTrabajadores}
                        isClearable />
                </Col>
            </Row>
        </> : <Loading className="text-center" />;
    }
}
